<template>
  <div v-if="lieuEnCours" class="container-fluid">
    <EditionStructureMenu ref="editionStructureMenu" />

    <div class="row">
      <!-- Informations générales -->
      <div class="col-12">
        <div class="row">
          <div class="col-9">
            <div class="form-group">
              <label :for="'libelle' + lieuEnCours.id">Nom</label>
              <input @focus="$event.target.select()" :disabled="lectureSeule" class="form-control" :id="'libelle' + lieuEnCours.id" type="text" v-model="lieuEnCours.libelle" maxlength="120">
              <div class="error" v-if="!nomValide">Ce champ est requis</div>
            </div>
          </div>
          <div class="col-3">
            <div class="form-group">
              <label :for="'liaison' + lieuEnCours.id">Type de liaison</label>
              <!-- <v-select id="selLiaison" v-model="familleSelect" :options="optionsFamilles" value="id" label="nom" :clearable="false" @input="selectFamilleDeProduit($event)" /> -->
              <v-select :id="'liaison' + lieuEnCours.id" :disabled="lectureSeule" v-model="lieuEnCours.typeLiaisonId" class="w-100" placeholder="Type de liaison" :options="[{ value: 1, label: 'Chaude' }, { value: 2, label: 'Froide' }]" :clearable="false" />
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-12">
            <div class="form-group">
              <label :for="'adresse1' + lieuEnCours.id">Adresse</label>
              <input @focus="$event.target.select()" :disabled="lectureSeule" class="form-control" :id="'adresse1' + lieuEnCours.id" type="text" v-model="lieuEnCours.adresse1" maxlength="50">
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-6">
            <div class="form-group">
              <label :for="'adresse2' + lieuEnCours.id">Complément d'adresse 1</label>
              <input @focus="$event.target.select()" :disabled="lectureSeule" class="form-control" :id="'adresse2' + lieuEnCours.id" type="text" v-model="lieuEnCours.adresse2" maxlength="50">
            </div>
          </div>
          <div class="col-6">
            <div class="form-group">
              <label :for="'adresse3' + lieuEnCours.id">Complément d'adresse 2</label>
              <input @focus="$event.target.select()" :disabled="lectureSeule" class="form-control" :id="'adresse3' + lieuEnCours.id" type="text" v-model="lieuEnCours.adresse3" maxlength="50">
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-2">
            <div class="form-group">
              <label :for="'codePostal' + lieuEnCours.id">Code postal</label>
              <input @focus="$event.target.select()" :disabled="lectureSeule" class="form-control" :id="'codePostal' + lieuEnCours.id" type="text" v-model="lieuEnCours.codePostal">
            </div>
          </div>
          <div class="col-10">
            <div class="form-group">
              <label :for="'ville' + lieuEnCours.id">Ville</label>
              <input @focus="$event.target.select()" :disabled="lectureSeule" class="form-control" :id="'ville' + lieuEnCours.id" type="text" v-model="lieuEnCours.ville">
            </div>
          </div>
        </div>

        <div class="row mt-3 mb-2">
          <div class="col-10">
            <div class="form-group">
              <label>Jours de consommation</label>
              <div class="flex-start" :key="'jours'+keyEffectifsModifies">
                <label class="label-checkbox-petitelargeur"><input type="checkbox" :disabled="lectureSeule" :checked="lieuEnCours.joursConsommation.includes(1)" @change="jourChanged(1, $event)"><span class="ml-2">Lundi</span></label><br/>
                <label class="label-checkbox-petitelargeur ml-4"><input type="checkbox" :disabled="lectureSeule" :checked="lieuEnCours.joursConsommation.includes(2)" @change="jourChanged(2, $event)"><span class="ml-2">Mardi</span></label><br/>
                <label class="label-checkbox-petitelargeur ml-4"><input type="checkbox" :disabled="lectureSeule" :checked="lieuEnCours.joursConsommation.includes(3)" @change="jourChanged(3, $event)"><span class="ml-2">Mercredi</span></label><br/>
                <label class="label-checkbox-petitelargeur ml-4"><input type="checkbox" :disabled="lectureSeule" :checked="lieuEnCours.joursConsommation.includes(4)" @change="jourChanged(4, $event)"><span class="ml-2">Jeudi</span></label><br/>
                <label class="label-checkbox-petitelargeur ml-4"><input type="checkbox" :disabled="lectureSeule" :checked="lieuEnCours.joursConsommation.includes(5)" @change="jourChanged(5, $event)"><span class="ml-2">Vendredi</span></label><br/>
                <label class="label-checkbox-petitelargeur ml-4"><input type="checkbox" :disabled="lectureSeule" :checked="lieuEnCours.joursConsommation.includes(6)" @change="jourChanged(6, $event)"><span class="ml-2">Samedi</span></label><br/>
                <label class="label-checkbox-petitelargeur ml-4"><input type="checkbox" :disabled="lectureSeule" :checked="lieuEnCours.joursConsommation.includes(0)" @change="jourChanged(0, $event)"><span class="ml-2">Dimanche</span></label><br/>
              </div>
            </div>
          </div>
          <div class="col-2">
            <div class="form-group">
              <label :for="'separation' + lieuEnCours.id" title="Sur les bons de livraison, on sépare par régime et texture">Séparation sur BL</label>
              <ToggleButton :disabled="lectureSeule" :id="'separation' + lieuEnCours.id" v-model="lieuEnCours.regimesSepares" :labels="{checked: 'Oui', unchecked: 'Non'}" :color="{checked: '#16D39A', unchecked: '#CCCCCC'}" :height="30" :width="85" :key="lieuEnCours.id"/>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Configuration de la répartition des effectifs -->
    <div class="row">
      <div class="col-12" :key="'effectifs'+keyEffectifsModifies">
        <div v-for="(typeConvive, iTypeConvive) in lieuEnCours.typesConvives" :key="'typeConvive'+iTypeConvive">
          <div class="card border-secondary">
            <div :class="'card-header flex-center-space-between ' + (lectureSeule ? 'bg-secondary' : estDoublon(typeConvive, lieuEnCours.typesConvives) ? 'bg-danger' : '')">
              <span>{{ afficherTexteAEffectif(typeConvive) }}</span>
              <!-- <button type="button" class="btn btn-danger btn-sm" v-tooltip="{ content: 'Supprimer cet effectif'}" @click="supprimerEffectif(effectif)">
                <i class="fas fa-trash"></i>
              </button> -->
            </div>
            <div class="card-body">
              <div class="row">
                <div class="col-10">
                  <div class="form-group">
                    <v-select class="w-100" :disabled="lectureSeule" placeholder="Types de convives" v-model="typeConvive.typeConviveChoisi" :options="convivesTypesNonNeutre" value="id" label="nom" :clearable="false" @input="selectionnerTypeConvive(typeConvive, typeConvive.typeConviveChoisi)" />
                    <div class="error" v-if="!typeConvive.typeConviveId">Ce champ est requis</div>
                  </div>
                </div>
                <div class="col-2">
                  <BoutonGestionBarquettes :dropLeft="true" />
                  <!-- <BoutonGestionBarquettes :listeBarquetteSelectionnee="effectif.barquettes" :listeBarquette="listeBarquettes" :dropLeft="true" @enregistrer="enregistrerBarquettesEffectif(effectif, $event)" /> -->
                </div>
              </div>

              <div class="card">
                <table class="table table-bordered table-sm text-center table-header-secondary">
                  <colgroup>
                    <col> <!-- Structure de menu -->
                    <col width="180"> <!-- Service -->
                    <col width="180"> <!-- Régime -->
                    <col width="180">  <!-- Texture -->
                    <col width="90">  <!-- Nb. couverts -->
                    <col width="40">  <!-- Plat témoin -->
                    <col width="40">  <!-- Actions -->
                  </colgroup>
                  <thead>
                    <th>Structure de menu</th>
                    <th>Service</th>
                    <th>Régime</th>
                    <th>Texture</th>
                    <th>Nb. couverts</th>
                    <th>T.</th>
                    <th>
                      <button type="button" :disabled="lectureSeule" class="btn btn-primary btn-sm m-0" v-tooltip="{ content: 'Ajouter un effectif'}" @click="addEffectif(typeConvive)">
                        <i class="fas fa-plus"></i>
                      </button>
                    </th>
                  </thead>
                </table>
                <div class="table-body">
                  <table class="table table-bordered table-sm text-center">
                    <colgroup>
                      <col> <!-- Structure de menu -->
                      <col width="180"> <!-- Service -->
                      <col width="180"> <!-- Régime -->
                      <col width="180">  <!-- Texture -->
                      <col width="90">  <!-- Nb. couverts -->
                      <col width="40">  <!-- Plat témoin -->
                      <col width="40">  <!-- Actions -->
                    </colgroup>
                    <tbody>
                      <template v-for="(effectif, iEffectif) in typeConvive.syntheseEffectifs">
                        <!--Ligne du lieu de consommation-->
                        <tr :class="[{'td-border-top-error td-border-left-error td-border-right-error': estDoublon(effectif, typeConvive.syntheseEffectifs)}]" :key="'data'+iEffectif+'syntheseChange'+keySyntheseEffectifs">
                          <!-- <td class="input"><v-select class="w-100" id="selTypeConvive" placeholder="Type de convive..." v-model="effectif.typeConviveId" :options="optionsConviveType" value="id" label="nom" :clearable="false" /></td> -->
                          <td class="input">
                            <div class="w-100 flex-start">
                              <v-select class="w-100 mr-1" :disabled="lectureSeule" placeholder="Type de menu" v-model="effectif.structureChoisie" :options="structures" value="id" label="nom" :clearable="false" @input="selectionnerStructureMenu(effectif, effectif.structureChoisie)" />
                              <button v-if="effectif && effectif.structureMenuId" type="button" :disabled="lectureSeule" class="btn btn-primary btn-sm mr-1" v-tooltip="{ content: 'Ouvrir la structure de menu sélectionnée'}" @click="ouvrirStructureMenu(effectif.structureMenuId)">
                                <i class="fas fa-pen"></i>
                              </button>
                              <button v-else type="button" :disabled="lectureSeule" class="btn btn-primary btn-sm mr-1" v-tooltip="{ content: 'Créer une nouvelle structure de menu'}" @click="creerStructureMenu(effectif.structureMenuId)">
                                <i class="fas fa-plus"></i>
                              </button>
                            </div>
                            <div class="error" v-if="!effectif.structureMenuId">Ce champ est requis</div>
                            <!-- <div v-if="estDoublon(effectif)" class="error pl-1 pt-0 mt-0">Il existe déjà une configuration identique (même structure de menu, même service, même régime et même texture)</div> -->
                          </td>
                          <td class="input">
                            <v-select class="w-100" :disabled="!effectif.structureMenuId || lectureSeule" v-model="effectif.typeServiceChoisi" :options="services" value="id" label="nom" :clearable="false" @input="selectionnerTypesServices(effectif, effectif.typeServiceChoisi)" />
                          </td>
                          <td class="input">
                            <v-select class="w-100" :disabled="!effectif.structureMenuId || lectureSeule" v-model="effectif.typeRegimeChoisi" :options="regimes" value="id" label="nom" :clearable="false" @input="selectionnerTypeRegime(effectif, effectif.typeRegimeChoisi)" />
                            <div class="error" v-if="!effectif.typeRegimeId">Ce champ est requis</div>
                          </td>
                          <td class="input">
                            <v-select class="w-100" :disabled="!effectif.structureMenuId || lectureSeule" v-model="effectif.typeTextureChoisi" :options="textures" value="id" label="nom" :clearable="false" @input="selectionnerTypeTexture(effectif, effectif.typeTextureChoisi)" />
                            <div class="error" v-if="!effectif.typeTextureId">Ce champ est requis</div>
                          </td>
                          <td class="input">
                            <InputNumber :disabled="!effectif.structureMenuId || lectureSeule" v-model="effectif.effectifs" typeFiltre="quantiteEntiere" style="width:100%;" title="Effectif" @input="effectifsChanged(effectif)" />
                          </td>
                          <td class="input"><input type="checkbox" :disabled="lectureSeule" id="platTemoin" v-model="effectif.aPlatTemoin" /></td>
                          <td>
                            <button type="button" :disabled="lectureSeule" class="btn btn-danger btn-sm" v-tooltip="{ content: 'Supprimer cet effectif'}" @click="supprimerEffectif(typeConvive, iEffectif)">
                              <i class="fas fa-trash"></i>
                            </button>
                          </td>
                        </tr>
                        <tr v-if="estDoublon(effectif, typeConvive.syntheseEffectifs)" :class="[{'td-border-bottom-error td-border-left-error td-border-right-error': estDoublon(effectif, typeConvive.syntheseEffectifs)}]" :key="'err'+iEffectif">
                          <td colspan="7" class="error">
                            Il existe déjà une configuration identique (même structure de menu, même service, même régime et même texture)
                          </td>
                        </tr>
                      </template>
                    </tbody>
                  </table>
                </div>
              </div>


              <!-- <div class="row">
                <div class="col-2">
                  <div class="form-group">
                    <label>Structure de menu</label>
                  </div>
                </div>
                <div class="col-2">
                  <div class="form-group">
                    <label>Régime</label>
                  </div>
                </div>
                <div class="col-2">
                  <div class="form-group">
                    <label>Texture</label>
                  </div>
                </div>
                <div class="col-2">
                  <div class="form-group">
                    <label>Service</label>
                  </div>
                </div>
                <div class="col-2">
                  <div class="form-group">
                    <label>Effectif</label>
                  </div>
                </div>
                <div class="col-1">
                  <div class="form-group">
                    <label>T.</label>
                  </div>
                </div>
                <div class="col-1">
                  <div class="form-group">
                    <label>
                      <button type="button" class="btn btn-primary btn-sm" v-tooltip="{ content: 'Ajouter un effectif'}" @click="ajouterEffectif(effectif)">
                        <i class="fas fa-plus"></i>
                      </button>
                    </label>
                  </div>
                </div>
              </div>
              <template v-for="(effectif, iEffectif) in effectifsTypeConvive(typeConvive)">
                <div :key="iEffectif" :class="[{'border-error pl-1 mb-1': estDoublon(effectif)}]">
                  <div class="row">
                    <div class="col-2">
                      <div class="form-group">
                        <b-form-select v-model="effectif.structureMenuId" :options="structures" value-field="id" text-field="nom">
                          <template slot="first">
                            <option :value="null" disabled>Structure de menu...</option>
                          </template>
                        </b-form-select>
                      </div>
                      <div class="error" v-if="!effectif.structureMenuId">Ce champ est requis</div>
                    </div>
                    <div class="col-2">
                      <div class="form-group">
                        <b-form-select v-model="effectif.regimeId" :options="optionsRegimes" style="margin-top:3px;">
                          <template slot="first">
                            <option :value="null" disabled>Régime...</option>
                          </template>
                        </b-form-select>
                        <div class="error" v-if="!effectif.regimeId">Ce champ est requis</div>
                      </div>
                    </div>
                    <div class="col-2">
                      <div class="form-group">
                          <b-form-select v-model="effectif.textureId" :options="optionsTextures" style="margin-top:3px;">
                          <template slot="first">
                            <option :value="null" disabled>Texture...</option>
                          </template>
                        </b-form-select>
                        <div class="error" v-if="!effectif.textureId">Ce champ est requis</div>
                      </div>
                    </div>
                    <div class="col-2">
                      <div class="form-group">
                        <b-form-select v-model="effectif.serviceId" :options="optionsServices" v-tooltip="{ content: 'Sans sélection manuelle, tous les services sont sélectionnés', placement: 'top' }">
                          <template slot="first">
                            <option :value="null" disabled>Service...</option>
                          </template>
                        </b-form-select>
                      </div>
                    </div>
                    <div class="col-2">
                      <div class="form-group">
                        <InputNumber v-model="effectif.effectif" typeFiltre="quantiteEntiere" style="width:100%;" title="Effectif" />
                      </div>
                    </div>
                    <div class="col-1">
                      <div class="form-group">
                        <input type="checkbox" id="platTemoin" v-model="effectif.aPlatTemoin" /> -->
                        <!-- <ToggleButton v-model="effectif.aPlatTemoin" :labels="{checked: 'Oui', unchecked: 'Non'}" :color="{checked: '#16D39A', unchecked: '#CCCCCC'}" :height="30" :width="85" /> -->
                      <!-- </div>
                    </div>
                    <div class="col-1">
                      <div class="form-group">
                        <button type="button" class="btn btn-danger btn-sm" v-tooltip="{ content: 'Supprimer cet effectif'}" @click="supprimerEffectif(effectif)">
                          <i class="fas fa-trash"></i>
                        </button>
                      </div>
                    </div>
                  </div>
                  <div v-if="estDoublon(effectif)" class="error pl-1 pt-0 mt-0">Il existe déjà une configuration identique (même structure de menu, même service, même régime et même texture)</div>
                </div>
              </template> -->
            </div>
          </div>
        </div>
        <div class="error" v-if="effectifsEnCours.length === 0">
          Il faut indiquer au moins un effectif
        </div>
      </div>
    </div>




    <!-- <div class="form-group">
      <label>Capacité d'accueil</label>
    <div class="card table-scroll height-responsive-35">
      <table class="table table-bordered table-sm text-center table-header">
        <colgroup>
          <col width="220">
          <col width="100">
          <col>
          <col width="40">
          <col width="40">
        </colgroup>
        <thead>
          <th class="aligner-gauche">Type de convive</th>
          <th>Nb. couverts</th>
          <th>Type de menu</th>
          <th>T.</th>
          <th></th>
        </thead>
      </table>
      <div class="table-body">
        <table class="table table-bordered table-sm text-center">
          <colgroup>
            <col width="220">
            <col width="100">
            <col>
            <col width="40">
            <col width="35">
          </colgroup>
          <tbody>
            <template v-for="(effectif, iEffectif) in effectifsEnCours"> -->
              <!--Ligne du lieu de consommation-->
              <!-- <tr :key="iEffectif"> -->
                <!-- <td class="input"><v-select class="w-100" id="selTypeConvive" placeholder="Type de convive..." v-model="effectif.typeConviveId" :options="optionsConviveType" value="id" label="nom" :clearable="false" /></td> -->
                <!-- <td>{{ effectif.typeConviveId }}</td>
                <td class="input"><InputNumber class="w-100" v-model="effectif.effectif" typeFiltre="quantiteEntiere" title="Effectif" /></td>
                <td class="input"><v-select class="w-100" id="selTypeConvive" placeholder="Structure de menu..." v-model="effectif.structureMenuId" :options="structures" value="id" label="nom" :clearable="false" /></td>
                <td class="input"><input type="checkbox" id="platTemoin" v-model="effectif.aPlatTemoin" /></td>
                <td>
                  <button type="button" class="btn btn-danger btn-sm" v-tooltip="{ content: 'Supprimer cet effectif'}" @click="supprimerEffectif(effectif)">
                    <i class="fas fa-trash"></i>
                  </button>
                </td>
              </tr>
            </template>
          </tbody>
        </table>
      </div>
    </div>
    </div>-->

    
    <!-- <div v-for="(effectif, iEffectif) in effectifsEnCours" :key="'eff'+iEffectif">
      <div class="card border-secondary">
        <div :class="'card-header flex-center-space-between ' + (estDoublon(effectif) ? 'bg-danger' : '')">
          <span>{{ afficherTexteAEffectif(effectif) || 'Capacité d\'accueil' }}</span>
          <button type="button" class="btn btn-danger btn-sm" v-tooltip="{ content: 'Supprimer cet effectif'}" @click="supprimerEffectif(effectif)">
            <i class="fas fa-trash"></i>
          </button>
        </div>
        <div class="card-body">
          <div v-if="estDoublon(effectif)" class="error pt-2">Il existe déjà une configuration identique (même structure de menu, même service, même régime et même texture)</div>
          <div class="row">
            <div class="col-4">
              <div class="form-group flex-start">
                <v-select class="w-100" id="selTypeConvive" placeholder="Types de convives" :options="optionsConviveType" value="id" label="nom" :clearable="false" /> -->
                <!-- {{ effectif.typeConviveId }} -->
              <!-- </div>
            </div>
            <div class="col-2">
              <div class="form-group flex-start">
                <InputNumber class="w-100" v-model="effectif.effectif" typeFiltre="quantiteEntiere" title="Effectif" />
              </div>
            </div>
            <div class="col-4">
              <div class="form-group">
                <b-form-select v-model="effectif.structureMenuId" :options="structures" value-field="id" text-field="nom">
                  <template slot="first">
                    <option :value="null" disabled>Structure de menu...</option>
                  </template>
                </b-form-select>
              </div>
              <div class="error" v-if="!effectif.structureMenuId">Ce champ est requis</div>
            </div>
            <div class="col-2">
              <div class="form-group">
                <label>Plat témoin</label>
                <ToggleButton v-model="effectif.aPlatTemoin" :labels="{checked: 'Oui', unchecked: 'Non'}" :color="{checked: '#16D39A', unchecked: '#CCCCCC'}" :height="30" :width="85" />
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-2">
              <div class="form-group">
                <label>Effectif</label>
                <InputNumber v-model="effectif.effectif" typeFiltre="quantiteEntiere" style="width:100%;" title="Effectif" />
              </div>
            </div>
            <div class="col-8">
              <div class="form-group">
                <label>Service</label>
                <b-form-select v-model="effectif.serviceId" :options="optionsServices" v-tooltip="{ content: 'Sans sélection manuelle, tous les services sont sélectionnés', placement: 'top' }">
                  <template slot="first">
                    <option :value="null" disabled>Service...</option>
                  </template>
                </b-form-select>
              </div>
            </div>
            <div class="col-2">
              <BoutonGestionBarquettes :listeBarquetteSelectionnee="effectif.barquettes" :listeBarquette="listeBarquettes" :dropLeft="true" @enregistrer="enregistrerBarquettesEffectif(effectif, $event)" />
            </div>
          </div>
          <div class="row">
            <div class="col-6">
              <div class="form-group">
                <label>Régime</label>
                <b-form-select v-model="effectif.regimeId" :options="optionsRegimes" style="margin-top:3px;">
                  <template slot="first">
                    <option :value="null" disabled>Régime...</option>
                  </template>
                </b-form-select>
                <div class="error" v-if="!effectif.regimeId">Ce champ est requis</div>
              </div>
            </div>
            <div class="col-6">
              <div class="form-group">
                <label>Texture</label>
                  <b-form-select v-model="effectif.textureId" :options="optionsTextures" style="margin-top:3px;">
                  <template slot="first">
                    <option :value="null" disabled>Texture...</option>
                  </template>
                </b-form-select>
                <div class="error" v-if="!effectif.textureId">Ce champ est requis</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="error" v-if="effectifsEnCours.length === 0">
      Il faut indiquer au moins un effectif
    </div> -->
  </div>
    <!-- </template>
    <template slot="modal-footer">
      <div class="flex-center-space-between w-100">
        <div>
          <button type="button" class="btn btn-primary mr-2" :disabled="!lieuValide || lectureSeule" @click="addTypeConvive(lieuEnCours)">Ajouter un type de convive</button>
          <button type="button" class="btn btn-primary mr-2" :disabled="!lieuValide || lectureSeule" @click="afficherEffectifsDetailles()">Effectifs détaillés</button>
          <BoutonGestionBarquettes class="mr-4" :disabled="!lieuValide || lectureSeule" :dropLeft="true" />
        </div>
        <div>
          <button type="button" class="btn btn-secondary mr-2" @click="annulerEdition">Annuler</button>
          <button type="button" class="btn btn-primary" :disabled="!lieuValide" @click="enregistrerLieu">Enregistrer</button>
        </div>
      </div>
    </template>
  </b-modal> -->
</template>

<script>
import EditionStructureMenu from "@/components/Menus/EditionStructureMenu"
import InputNumber from "@/components/Inputs/InputNumber"
import BoutonGestionBarquettes from "@/components/Divers/BoutonGestionBarquettes"
import { connecteData } from "@/mixins/connecteData"
import { getLieuConsommation, chargerStructuresMenusDetaillees } from "@/api/gpao/menus"
import { effectifsLieuConsommation, optionsJours } from '@/mixins/menus'
import { alerteDonneesModifiees } from "@/mixins/index"
import { mapGetters } from "vuex"
import _ from 'lodash'

export default {
  name: "EditionLieuConsommation",
  props: {
    "lieuConsommationId": Number,
    "effectifsDetailles": Array,
    //"structures": Array,
    "barquettes": Array
  },
  components: { EditionStructureMenu, InputNumber, BoutonGestionBarquettes },
  mixins: [ connecteData, alerteDonneesModifiees, effectifsLieuConsommation, optionsJours ],
  data() {
    return {
      keySyntheseEffectifs: 1,
      keyEffectifsModifies: 1,
      donneesInitiales: null,
      lieuEnCours: null,
      structures: []
    }
  },
  computed: {
    ...mapGetters("definitions", ["convivesTypesNonNeutre", "regimes", "textures", "services"]),
    //optionsConviveType() { return this.convivesTypesNonNeutre },
    //optionsRegimes() { return this.regimes },
    //optionsTextures() { return this.textures },
    //optionsServices() { return this.services },
    lectureSeule() { return !this.lieuEnCours?.actif ?? true },
    effectifsEnCours() {
      return this.lieuEnCours?.typesConvives?.flatMap(e => e.syntheseEffectifs)?.flatMap(e => e.detailsEffectifs) || []
      //return this.lieuEnCours?.typesConvives?.map(tc => tc.syntheseEffectifs)?.filter(x => x.effectif !== -1) || []
    },
    donneesModifiees() {
      return (!_.isEqual(JSON.stringify(this.donneesInitiales), JSON.stringify(this.lieuEnCours)))
    },
    // typesConvivesEnCours() {
    //   let tc = [...new Set(this.effectifsEnCours.map(e => e.typeConviveId))]
    //   debugger
    //   return [...new Set(this.effectifsEnCours.map(e => e.typeConviveId))]
    // },
    nomValide() {
      return this.lieuEnCours?.libelle?.length > 3
    },
    lieuValide() {
      // Vérification du nom du lieu de consommation
      if (!this.nomValide)
        return false  // Nom du lieu invalide

      // Vérification de la présence d'au moins un type de convive
      if (!this.lieuEnCours.typesConvives?.length)
        return false

      // Vérification de la présence d'au moins un effectif pour chaque type de convive
      if (this.lieuEnCours.typesConvives.some(tc => !tc.syntheseEffectifs?.filter(e => e.effectifs)?.length))
        return false

      // Vérification de la saisie correcte de chaque effectif
      if (this.lieuEnCours.typesConvives.some(tc => tc.syntheseEffectifs.some(e => !e.structureMenuId || !e.typeRegimeId || !e.typeTextureId)))
        return false

      // Vérification de la présence de doublons de types de convives
      if (this.lieuEnCours.typesConvives.some(tc => this.estDoublon(tc, this.lieuEnCours.typesConvives)))
        return false

      // Vérification de la présence de doublons d'effectifs au sein de chaque type de convive
      if (this.lieuEnCours.typesConvives.some(tc => tc.syntheseEffectifs.some(e => this.estDoublon(e, tc.syntheseEffectifs))))
        return false

      return true
    },
    strLieu() {
      return JSON.stringify(this.lieuEnCours)
    }
  },
  watch: {
    donneesModifiees() {
      this.$emit("donnees-modifiees", this.donneesModifiees)
    },
    strLieu() {
      this.$emit("lieu-modifie", _.cloneDeep(this.lieuEnCours))
    },
    effectifsEnCours() {
      this.$emit("effectifs-modifies", _.cloneDeep(this.effectifsEnCours))
    },
    effectifsDetailles() {
      this.lieuEnCours.typesConvives.forEach(tc => {
        tc.syntheseEffectifs = this.detailVersRecap(this.effectifsDetailles, true)
      })
      this.keyEffectifsModifies++
    }
  },
  methods: {
    async enregistrerDonneesModifiees() {
      await this.enregistrerLieu()
    },
    nouveauLieu() {
      return {
        etablissementId: this.etabCourantId,
        actif: true,
        libelle: 'Nouveau lieu',
        typeLiaisonId: null,
        adresse1: '',
        adresse2: '',
        adresse3: '',
        codePostal: '',
        ville: '',
        joursConsommation: [],
        // effectifsParDefaut: [],
        // typesConvives: []
        // typesConvives: [{
        //   typeConviveId: null,
        //   effectifs: [{
        //     typeConviveId: null,
        //     structureMenuId: null,
        //     typeServiceId: null,
        //     typeRegimeId: null,
        //     typeTextureId: null,
        //     effectifs: 0,
        //     aPlatTemoin: false,
        //     jour: null
        //   }]
        // }]
        //ordreLivraison: this.lieux.length ? Math.max.apply(Math, this.lieux.map(l => l.ordreLivraison)) + 1 : 1,
        //barquettes: _.cloneDeep(this.listeBarquettes) //Toutes les barquettes sélectionnées par défaut
      }
    },
    nouveauTypeConvive() {
      return {
        typeConviveId: null,
        nomTypeConvive: "",
        effectifs: [],
        syntheseEffectifs: []
      }
    },
    nouvelEffectifPourSynthese(typeConvive) {
      return {
        typeConviveId: typeConvive.typeConviveId,
        nomTypeConvive: typeConvive.nomTypeConvive,
        structureMenuId: null,
        typeServiceId: null,
        typeRegimeId: null,
        typeTextureId: null,
        nomStructureMenu: null,
        nomTypeService: null,
        nomTypeRegime: null,
        nomTypeTexture: null,
        structureChoisie: { id: null, nom: null },
        typesServicesChoisis: [],
        typeRegimeChoisi: { id: null, nom: null },
        typeTextureChoisi: { id: null, nom: null },
        effectifs: 0,
        aPlatTemoin: false,
        barquettes: this.barquettes
      }
    },
    creerNouveauLieu() {
      let nouveauLieu = this.nouveauLieu()
      this.addTypeConvive(nouveauLieu)
      return nouveauLieu
    },
    // show() {
    //   this.$refs.modalEditionLieuConsommation.show()
    // },
    // show(lieu, listeBarquettes) {
    //   if (!lieu)
    //     return
      
    //   //this.lieuEnCours = {...lieu}
    //   this.lieuEnCours = _.cloneDeep(lieu)
    //   this.listeBarquettes = listeBarquettes || []

    //   this.checkLieu()
    //   this.$refs.modalEditionLieuConsommation.show()
    // },
    // hide() {
    //   this.$refs.modalEditionLieuConsommation.hide()
    // },
    selectionnerTypeConvive(typeConviveAModifier, typeConviveChoisi) {
      typeConviveAModifier.typeConviveId = typeConviveChoisi.id
      typeConviveAModifier.nomTypeConvive = typeConviveChoisi.nom

      typeConviveAModifier.syntheseEffectifs.forEach(s => {
        this.recapChangeTypeConvive(s)
      })

      this.$emit("effectifs-modifies", _.cloneDeep(this.effectifsEnCours))

      // // Mise à jour du type de convive sur la synthèse des effectifs
      // typeConviveAModifier.syntheseEffectifs.forEach(e => {
      //   e.typeConviveId = typeConviveChoisi.id
      //   e.nomTypeConvive = typeConviveChoisi.nom
      // })

      // // Mise à jour du type de convive sur les effectifs
      // typeConviveAModifier.effectifs.forEach(e => {
      //   e.typeConviveId = typeConviveChoisi.id
      //   e.nomTypeConvive = typeConviveChoisi.nom
      // })
    },
    async selectionnerStructureMenu(structureMenuAModifier, structureMenuChoisie) {
      structureMenuAModifier.structureMenuId = structureMenuChoisie.id
      structureMenuAModifier.nomStructureMenu = structureMenuChoisie.nom

      //let response = await obtenirMenuStructure(structureMenuAModifier.structureMenuId)
      //let structure = response.data

      this.recapChangeCategorie(structureMenuAModifier, this.structures)

      this.$emit("effectifs-modifies", _.cloneDeep(this.effectifsEnCours))
    },
    selectionnerTypesServices(typesServicesAModifier, typesServicesChoisis) {
      typesServicesAModifier.typeServiceId = typesServicesChoisis.id
      typesServicesAModifier.nomTypeService = typesServicesChoisis.nom

      this.recapChangeCategorie(typesServicesAModifier)

      this.$emit("effectifs-modifies", _.cloneDeep(this.effectifsEnCours))
    },
    selectionnerTypeRegime(typeRegimeAModifier, typeRegimeChoisi) {
      typeRegimeAModifier.typeRegimeId = typeRegimeChoisi.id
      typeRegimeAModifier.nomTypeRegime = typeRegimeChoisi.nom

      this.recapChangeCategorie(typeRegimeAModifier)

      this.$emit("effectifs-modifies", _.cloneDeep(this.effectifsEnCours))
    },
    selectionnerTypeTexture(typeTextureAModifier, typeTextureChoisi) {
      typeTextureAModifier.typeTextureId = typeTextureChoisi.id
      typeTextureAModifier.nomTypeTexture = typeTextureChoisi.nom

      this.recapChangeCategorie(typeTextureAModifier)

      this.$emit("effectifs-modifies", _.cloneDeep(this.effectifsEnCours))
    },
    effectifsChanged(effectifsAModifier) {
      this.recapChangeEffectifs(effectifsAModifier)

      this.$emit("effectifs-modifies", _.cloneDeep(this.effectifsEnCours))
    },
    // ModifierSyntheseEffectif(ancienEffectif, nouvelEffectif) {
    //   // Recherche des effectifs à modifier
    //   let anciensEffectifs = 
    // },
    creerStructureMenu() {
      this.$refs.editionStructureMenu.afficherModal()
    },
    ouvrirStructureMenu(structureMenuId) {
      this.$refs.editionStructureMenu.afficherModal(structureMenuId)
    },
    supprimerEffectif(typeConvive, position) {
      typeConvive.syntheseEffectifs.splice(position, 1)
      this.keySyntheseEffectifs++
    },
    afficherEffectifsDetailles() {

    },
    effectifsTypeConvive(typeConviveId) {
      //let e = this.effectifsEnCours
      //debugger
      return this.effectifsEnCours.filter(e => e.typeConviveId === typeConviveId)
    },
    addTypeConvive(lieu) {
      if (!lieu)
        lieu = this.lieuEnCours

      if (!lieu.typesConvives)
        lieu.typesConvives = []

      let nouveauTypeConvive = this.nouveauTypeConvive()
      this.addEffectif(nouveauTypeConvive)

      lieu.typesConvives.push(nouveauTypeConvive)
      //this.lieuEnCours.typesConvives.push({ structureMenuId: null, typeServiceId: null, typeRegimeId: null, typeTextureId: null, effectifs: 0, barquettes: [] })
    },
    addEffectif(typeConvive) {
      if (!typeConvive.syntheseEffectifs)
        typeConvive.syntheseEffectifs = []
      typeConvive.syntheseEffectifs.push(this.nouvelEffectifPourSynthese(typeConvive))
      this.keySyntheseEffectifs++
    },
    syntheseEffectifs(typeConvive) {
      return typeConvive.syntheseEffectifs
    },
    checkLieu() {
      if (!this.lieuEnCours.joursConsommation) {
        // Initialisation de la liste des jours
        this.lieuEnCours.joursConsommation = []
      }
      if (!this.lieuEnCours.typesConvives?.length) {
        // Initialisation de la liste des effectifs
        this.addTypeConvive()
      } else {
        // Mise en forme correcte des régimes et textures avec de ne pas avoir de valeur vide dans les configuration
        // => permet de corriger les anciennes configurations créées avant la mise en place des contrôles de saisie
        let regimeNormalId = [...this.regimes].sort((t1, t2) => t1.ordre - t2.ordre).first()?.value
        let textureNormaleId = [...this.textures].sort((t1, t2) => t1.ordre - t2.ordre).first()?.value
        if (!regimeNormalId && !textureNormaleId) {
          return
        }
        this.lieuEnCours.typesConvives.map(tc => tc.syntheseEffectifs).forEach(e => {
          if (!e.typeRegimeId && regimeNormalId) {
            e.typeRegimeId = regimeNormalId
          }
          if (!e.typeTextureId && textureNormaleId) {
            e.typeTextureId = textureNormaleId
          }
        })
      }
    },
    enregistrerLieu() {
      this.$emit("enregistrer-lieu", this.lieuEnCours)
    },
    annulerEdition() {
      this.$emit("annuler-edition")
    },
    enregistrerBarquettesLieu(dataBarquettes) {
      
      this.lieuEnCours.barquettes = []
      dataBarquettes.forEach(b => {
        this.lieuEnCours.barquettes.push(this.barquettes.filter(x => x.id === b.Id).first())
      })

      /*var data = this.lieuEnCours.donneesSupplementaires && JSON.parse(this.lieuEnCours.donneesSupplementaires.replaceAll("'", "\"")) || {}
      data.Barquettage = dataBarquettes
      this.lieuEnCours.donneesSupplementaires = JSON.stringify(data).replaceAll("\"", "'")*/

    },
    enregistrerBarquettesEffectif(effectif, dataBarquettes) {
      
      effectif.barquettes = []
      dataBarquettes.forEach(b => {
        effectif.barquettes.push(this.barquettes.filter(x => x.id === b.Id).first())
      })

      /*var data = effectif.donneesSupplementaires && JSON.parse(effectif.donneesSupplementaires.replaceAll("'", "\"")) || {}
      data.Barquettage = dataBarquettes
      effectif.donneesSupplementaires = JSON.stringify(data).replaceAll("\"", "'")*/
    },
    jourChanged(jour, ouvert) {
      if (ouvert.target.checked) {
        this.lieuEnCours.joursConsommation.push(jour)
      } else {
        _.remove(this.lieuEnCours.joursConsommation, e => e === jour)
      }
      this.lieuEnCours.typesConvives?.forEach(tc => {
        this.recapChangeJour(tc.effectifs, tc.syntheseEffectifs, this.optionsJours?.find(j => j.id === jour), this.lieuEnCours.joursConsommation)
      })
      // this.lieuEnCours.typesConvives?.forEach(tc => {
      //   let typeConviveOrigine = this.donneesInitiales.typesConvives?.find(o => o.typeConviveId === tc.typeConviveId)
      //   this.recapVersDetailsChangeJour(tc.effectifs, typeConviveOrigine.effectifs, this.lieuEnCours.joursConsommation, tc.syntheseEffectifs, jour, this.optionsJours?.find(j => j.id === jour))
      // })
      this.$emit("lieu-modifie", _.cloneDeep(this.lieuEnCours))
      this.$emit("effectifs-modifies", _.cloneDeep(this.effectifsEnCours))
      // this.recapVersDetailsChangeJour(this.lieuEnCours.effectifs, this.donneesInitiales.effectifs, this.lieuEnCours.joursConsommation, this.lieuEnCours.syntheseEffectifs, jour, this.optionsJours?.find(j => j.id === jour))
    },
    afficherTexteAEffectif(typeConvive) {
      //debugger
      let nbEffectifs = 0
      if (typeConvive?.syntheseEffectifs?.length) {
        nbEffectifs = typeConvive.syntheseEffectifs.map(e => e.effectifs).reduce((a,c) => a + c, 0)
      }
      let capaciteAccueil = "Nb couverts : " + nbEffectifs

      if (!typeConvive?.nomTypeConvive)
        return capaciteAccueil

      // if (!effectif || (effectif && !effectif.structureMenuId))
      //   return capaciteAccueil
      
      let informations = [
        typeConvive?.nomTypeConvive,
        capaciteAccueil
      ]

      return informations.filter(i => i).join(" - ")
    },
    estDoublon(element, liste) {
      let doublons = []
      if (element.structureMenuId) {
        // Nous sommes sur un effectif car ce sont les effectifs qui portent les structures de menus
        doublons = liste.filter(e => e.structureMenuId == element.structureMenuId && e.typeServiceId == element.typeServiceId
          && e.typeRegimeId == element.typeRegimeId && e.typeTextureId == element.typeTextureId) || []
      } else {
        // Nous sommes sur un type de convive dans le cas contraire
        doublons = liste.filter(e => e.typeConviveId == element.typeConviveId) || []
      }
      return doublons.length > 1
    },
    async chargerLieuConsommation() {
      if (this.lieuConsommationId) {
        let response = await getLieuConsommation(this.lieuConsommationId)
        this.lieuEnCours = response.data
      } else {
        this.lieuEnCours = this.creerNouveauLieu()
      }
      this.lieuEnCours.typesConvives.forEach(tc => {
        tc.typeConviveChoisi = { id: tc.typeConviveId, nom: tc.nomTypeConvive }
        tc.syntheseEffectifs = this.detailVersRecap(tc.effectifs, true)
      })
      this.checkLieu()
      this.donneesInitiales = _.cloneDeep(this.lieuEnCours)
    },
    async chargerStructuresMenus() {
      let response = await chargerStructuresMenusDetaillees(this.etabCourantId)
      this.structures = response.data
    }
  },
  mounted() {
    this.chargerLieuConsommation()
    this.chargerStructuresMenus()
  }
}

</script>
